import type { ReactNode } from 'react';

interface Props {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  extra?: ReactNode;
}

export function HeroBlock({
  title = 'AI для бизнеса',
  subtitle = 'Широкие возможности для продуктивной работы',
  children,
  extra,
}: Props) {
  return (
    <>
      <div className="wave-bg" aria-hidden="true" />
      <div className="absolute inset-0 z-1 overflow-y-auto">
        <div className="min-h-full flex flex-col items-center justify-center w-full px-6 py-[clamp(40px,8vh,120px)]">
          <div className="w-full max-w-[52.5rem] flex flex-col items-stretch gap-[clamp(20px,3vh,40px)]">
            <div className="text-center flex flex-col items-center gap-1">
              <h1 className="font-display font-semibold text-black/90 tracking-[-1px] leading-7 text-2xl">
                {title}
              </h1>
              {subtitle && (
                <p className="font-sans text-base font-normal text-black/50 tracking-body leading-6">
                  {subtitle}
                </p>
              )}
            </div>
            <div className="w-full">{children}</div>
            {extra && <div className="w-full">{extra}</div>}
          </div>
        </div>
      </div>
    </>
  );
}
